import type { ReactNode } from 'react';
import { Flex, Link, Text } from '@backstage/ui';
import { HomeCard } from './HomeCard';

export type Tool = {
  label: string;
  url: string;
  icon: ReactNode;
};

/**
 * The home page "Toolkit" card on BUI, in place of @backstage/plugin-home's
 * Material-UI HomePageToolkit: the same wrapping grid of round 64px icon tiles
 * with a 72px label under each, every tile a link to the tool.
 */
export const ToolkitCard = ({ tools }: { tools: Tool[] }) => (
  <HomeCard title="Toolkit">
    <Flex gap="0" style={{ flexWrap: 'wrap', textAlign: 'center' }}>
      {tools.map(tool => (
        <Link
          key={tool.url}
          href={tool.url}
          standalone
          style={{ margin: 'var(--bui-space-1) var(--bui-space-2)' }}
        >
          <Flex direction="column" align="center">
            <Flex
              align="center"
              justify="center"
              style={{
                width: 64,
                height: 64,
                borderRadius: 'var(--bui-radius-full)',
                border: '1px solid var(--bui-border-1)',
                backgroundColor: 'var(--bui-bg-neutral-2)',
                // Monochrome logos (GitHub, CircleCI) take the text colour,
                // so they stay visible in both themes.
                color: 'var(--bui-fg-primary)',
              }}
            >
              {tool.icon}
            </Flex>
            <Text
              as="span"
              variant="body-small"
              color="secondary"
              style={{
                marginTop: 'var(--bui-space-2)',
                width: 72,
                lineHeight: 1.25,
                overflowWrap: 'break-word',
              }}
            >
              {tool.label}
            </Text>
          </Flex>
        </Link>
      ))}
    </Flex>
  </HomeCard>
);
